import { IsString } from 'class-validator';

export const EMAIL_OTP_LENGTH = 6;

export type EmailOTPValidationResponse = { verified: boolean };

export interface EmailOTPDto extends EmailOTPValidationResponse {
  id: string;
}

export class UpdateEmailOTPDto {
  @IsString()
  code: string;
}
